const page_schema = {
	"tiers": [
		{
			"name": "Feature",
			"type": "checkbox",
			"id": "features",
			"class_name": "tags",
			"child_name": "feature",
			"options": [
				{
					"name": "PCR/qPCR",
					"id": "pcr-qpcr"
				},
				{
					"name": "Nucleosomal Analysis",
					"id": "nucleosomal-analysis"
				},
				{
					"name": "Methylase",
					"id": "methylase"
				},
				{
					"name": "5-hmC Enrichment",
					"id": "5-hmc-enrichment"
				},
				{
					"name": "Complete Digestion",
					"id": "complete-digestion"
				},
				{
					"name": "Fragmentation",
					"id": "fragmentation"
				},
			]
		},
		{
			"name": "d-none",
			"type": "checkbox",
			"id": "d-none",
			"class_name": "tags",
			"child_name": "d-none",
			"options": [
				{
					"name": "dNTP Solutions",
					"id": "dntp-solutions"
				},
				{
					"name": "Methylated & Hydroxymethylated Nucleotides",
					"id": "methylated-hydroxymethylated-nucleotides"
				},
				{
					"name": "Modification Enzymes for Epigenetics",
					"id": "modification-enzymes"
				},
				{
					"name": "DNA Fragmentation Enzymes",
					"id": "dna-fragmentation-enzymes"
				},
			]
		},
	],
	"filters": [],
	"products": {
		"Micrococcal Nuclease": {
			"title": "Micrococcal Nuclease",
			"catalogNumbers": "D5220-1",
			"description": "Cleaves single-stranded and double-stranded DNA and RNA. Complete digestion with Micrococcal Nuclease yields mono- and oligonucleotides with 3'-phosphates.",
			"handle": "/products/micrococcal-nuclease",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5220-1_Micrococcal-Nuclease.jpg?v=1628532397&width=600",
			"generalIndex": "998",
			"id": "micrococcal-nuclease",
			"tags": [
				"nucleosomal-analysis",
				"dna-fragmentation-enzymes"
			],
			filters: []
		},
		"ZymoTaq PreMix": {
			"title": "ZymoTaq PreMix",
			"catalogNumbers": "E2003, E2004",
			"description": "ZymoTaq PreMix is supplied as a 2X concentrated “master mix” containing all the reagents needed to perform “hot start” PCR. The inclusion of a heat-activated, thermal-stable DNA polymerase reduces primer dimer and non-specific product formation that can occur when performing conventional PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection.",
			"handle": "/products/zymotaq-premix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2003_ZymoTaq-PreMix.jpg?v=1628532368&width=600",
			"generalIndex": "998",
			"id": "zymotaq-premix",
			"tags": [
				"pcr-qpcr",
			],
			filters: []
		},
		"ZymoTaq DNA Polymerase": {
			"title": "ZymoTaq DNA Polymerase",
			"catalogNumbers": "E2001, E2002",
			"description": "ZymoTaq DNA Polymerase contains all the reagents needed to perform “hot-start” PCR. The inclusion of a heat-activated, thermostable DNA polymerase reduces primer dimer and nonspecific product formation that can occur during PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection, but is applicable for conventional PCR. ",
			"handle": "/products/zymotaq-dna-polymerase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2001_ZymoTaq-Polymerase.jpg?v=1628532372&width=600",
			"generalIndex": "998",
			"id": "zymotaq-dna-polymerase",
			"tags": [
				"pcr-qpcr",
			],
			filters: []
		},
		"ZymoTaq qPCR Premix": {
			"title": "ZymoTaq qPCR Premix",
			"catalogNumbers": "E2054, E2055",
			"description": "ZymoTaq qPCR PreMix contains all the reagents needed to perform quantitative PCR and other molecular downstream analysis such as high-resolution melt (HRM) analysis of DNA methylation and other general real-time PCR assays. This premix features a hot-start DNA polymerase and buffer system optimized for the amplification of bisulfite-treated DNA. It also includes an intense dsDNA-specific fluorescent dye, SYTO 9, for sensitive real-time DNA quantification.",
			"handle": "/products/zymotaq-qpcr-premix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2054_ZymoTaq-qPCR-Premix.jpg?v=1628532408&width=600",
			"generalIndex": "998",
			"id": "zymotaq-qpcr-premix",
			"tags": [
				"pcr-qpcr",
			],
			filters: []
		},
		"DNA Degradase Plus": {
			"title": "DNA Degradase Plus",
			"catalogNumbers": "E2020, E2021",
			"description": "DNA Degradase Plus from Zymo Research is a nuclease mix that quickly and efficiently degrades DNA to its individual nucleoside components. Since nucleosides lack negatively charged phosphate, DNA Degradase Plus is ideal for whole-genome DNA methylation analysis by LC/MS. Digestion with the enzyme is performed via a one-step procedure that is faster and simpler than other available methods.",
			"handle": "/products/dna-degradase-plus",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2020_DNA-Degradase-Plus.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "dna-degradase-plus",
			"tags": [
				"complete-digestion",
				"dna-fragmentation-enzymes"
			],
			filters: []
		},
		"dsDNA Shearase Plus": {
			"title": "dsDNA Shearase Plus",
			"catalogNumbers": "E2018-50, E2018-200",
			"description": "dsDNA Shearase Plus is an endonuclease that cleaves phosphodiester bonds in DNA to yield oligonucleotides with 5'-phosphate and 3'-hydroxyl termini. It has a particularly strong preference for dsDNA and generates random-ended DNA fragments of the desired size in a single step. This enzyme is compatible with low volume inputs, thus minimizing sample loss.",
			"handle": "/products/dsdna-shearase-plus",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2018-50_dsDNA-Shearase-Plus-50-U.jpg?v=1628532407&width=600",
			"generalIndex": "998",
			"id": "dsdna-shearase-plus",
			"tags": [
				"fragmentation",
				"dna-fragmentation-enzymes"
			],
			filters: []
		},
		"CpG Methylase (M. Sssl)": {
			"title": "CpG Methylase (M. Sssl)",
			"catalogNumbers": "E2010, E2011",
			"description": "CpG Methylase (M. SssI) ensures complete, in vitro methylation of DNA for methylation analysis.",
			"handle": "/products/cpg-methylase-m-sssl",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2010_CpG-Methylase.jpg?v=1628532396&width=600",
			"generalIndex": "998",
			"id": "cpg-methylase-m-sssl",
			"tags": [
				"methylase",
				"modification-enzymes"
			],
			filters: []
		},
		"5-hmC Glucosyltransferase": {
			"title": "5-hmC Glucosyltransferase",
			"catalogNumbers": "E2026, E2027",
			"description": "The 5-hmC Glucosyltransferase is a highly active enzyme that specifically tags 5-hydroxymethylcytosine in DNA with a glucose moiety to yield glucosyl-5-hydroxymethylcytosine, which in turn can be used for sequence-specific, genome-wide, or global 5-hmC detection.",
			"handle": "/products/5-hmc-glucosyltransferase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2026_5-hmC-Glucosyltransferase.jpg?v=1628532397&width=600",
			"generalIndex": "998",
			"id": "5-hmc-glucosyltransferase",
			"tags": [
				"5-hmc-enrichment",
				"modification-enzymes"
			],
			filters: []
		},
		"Atlantis dsDNase": {
			"title": "Atlantis dsDNase",
			"catalogNumbers": "E2030",
			"description": "Atlantis dsDNase is a double-stranded DNA-specific endonuclease that cleaves phosphodiester bonds in DNA to yield homogeneous populations of core nucleosomes.",
			"handle": "/products/atlantis-ds-dnase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2030_Atlantis-dsDNase-12.5-U.jpg?v=1628532394&width=600",
			"generalIndex": "998",
			"id": "atlantis-ds-dnase",
			"tags": [
				"nucleosomal-analysis",
				"dna-fragmentation-enzymes"
			],
			filters: []
		},
		"DNA Degradase": {
			"title": "DNA Degradase",
			"catalogNumbers": "E2016, E2017",
			"description": "DNA Degradase from Zymo Research is a nuclease mix that quickly and efficiently degrades DNA to its individual nucleotide components. DNA Degradase is ideal for whole-genome DNA methylation analysis by many downstream applications (i.e., HPLC, TLC, etc.). Digestion with the enzyme is performed via a one-step procedure that is faster and simpler than other available methods.",
			"handle": "/products/dna-degradase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2016_DNA-Degradase.jpg?v=1628532393&width=600",
			"generalIndex": "998",
			"id": "dna-degradase",
			"tags": [
				"complete-digestion",
				"dna-fragmentation-enzymes"
			],
			filters: []
		},
		"5-Methyl dCTP": {
			"title": "5-Methyl dCTP",
			"catalogNumbers": "D1035",
			"description": "Modified deoxynucleotide for use with PCR, mass spec, etc.",
			"handle": "/collections/methylated-nucleotides/products/5-methyl-dctp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1035_Methylated-and-Hydroxymethylated-Nucleotides.jpg?v=1628532399&width=600",
			"generalIndex": "998",
			"id": "5-methyl-dctp",
			"tags": [
				"pcr-qpcr",
				"methylated-hydroxymethylated-nucleotides"
			],
			filters: []
		},
		"5-Methylcytosine dNTP Mix": {
			"title": "5-Methylcytosine dNTP Mix",
			"catalogNumbers": "D1030",
			"description": "dNTP mixture containing the modified deoxynucleotide 5-mC for use with PCR, mass spec, etc.",
			"handle": "/collections/methylated-nucleotides/products/5-methylcytosine-dntp-mix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1030_Methylated-and-Hydroxymethylated-Nucleotides.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "5-methylcytosine-dntp-mix",
			"tags": [
				"pcr-qpcr",
				"methylated-hydroxymethylated-nucleotides"
			],
			filters: []
		},
		"dNTP Mix": {
			"title": "dNTP Mix",
			"catalogNumbers": "D1000, D1000-1",
			"description": "dATP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
			"handle": "/collections/dntp-solutions/products/dntp-mix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1000_dNTPs.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "dntp-mix",
			"tags": [
				"pcr-qpcr",
				"dntp-solutions"
			],
			filters: []
		},
		"dCTP": {
			"title": "dCTP",
			"catalogNumbers": "D1020",
			"description": "Ultra pure dCTP can be used in nucleotide mixtures to generate PCR amplicons using ZymoTaq, QuestTaq or other DNA polymerases.",
			"handle": "/collections/dntp-solutions/products/dctp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1020_dCTP.jpg?v=1628532398&width=600",
			"generalIndex": "998",
			"id": "dctp",
			"tags": [
				"pcr-qpcr",
				"dntp-solutions"
			],
			filters: []
		},
		"dATP": {
			"title": "dATP",
			"catalogNumbers": "D1005",
			"description": "dATP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
			"handle": "/collections/dntp-solutions/products/datp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1005_dATP.jpg?v=1628532405&width=600",
			"generalIndex": "998",
			"id": "datp",
			"tags": [
				"pcr-qpcr",
				"dntp-solutions"
			],
			filters: []
		},
		"dTTP": {
			"title": "dTTP",
			"catalogNumbers": "D1010",
			"description": "dTTP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
			"handle": "/collections/dntp-solutions/products/dttp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1010_dTTP.jpg?v=1628532407&width=600",
			"generalIndex": "998",
			"id": "dttp",
			"tags": [
				"pcr-qpcr",
				"dntp-solutions"
			],
			filters: []
		},
		"dGTP": {
			"title": "dGTP",
			"catalogNumbers": "D1015",
			"description": "dGTP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
			"handle": "/collections/dntp-solutions/products/dgtp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1015_dGTP.jpg?v=1628532393&width=600",
			"generalIndex": "998",
			"id": "dgtp",
			"tags": [
				"pcr-qpcr",
				"dntp-solutions"
			],
			filters: []
		},
		"Endura Tn5 Transposase": {
			"title": "Endura Tn5 Transposase",
			"catalogNumbers": "E1024-20, E1024-100, E1024-4-5, E1025-20, E1025-100",
			"description": "Superior Stability & Compatible with Any Adapter.",
			"handle": "/products/endura-tn5-transposase-unloaded",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/files/photo1_600x.webp?v=1750810168",
			"generalIndex": "998",
			"id": "endura-tn5-transposase",
			"tags": [
				"nucleosomal-analysis",
				"fragmentation"
			],
			filters: []
		},
	}
}